<template>
    <div>
        <DataTable :value="relationshipTypes" :loading="isLoading" class="p-datatable-sm" removableSort>
            <Column field="name" header="Nome" sortable />
            <Column v-if="!isPredefinedTab" header="Origem" field="origin" sortable >
                <template #body="{ data }">
                    <!-- Origin is classified by the backend (data.origin / data.based_on); the UI
                         only maps each kind to an icon + colour. -->
                    <Tag
                        v-if="data.origin === 'copy'"
                        severity="info"
                        v-tooltip.top="'Cópia de um tipo pré-definido'"
                    >
                        <span class="material-icons text-sm mr-1 align-middle">content_copy</span>
                        {{ data.based_on }}
                    </Tag>
                    <Tag
                        v-else-if="data.origin === 'derived'"
                        severity="warn"
                        v-tooltip.top="'Derivado de um dos seus tipos'"
                    >
                        <span class="material-icons text-sm mr-1 align-middle">account_tree</span>
                        {{ data.based_on }}
                    </Tag>
                    <span v-else class="text-surface-400">Próprio</span>
                </template>
            </Column>
            <Column field="description" header="Descrição" />
            <Column field="entity_types" header="Aplica-se a" sortable>
                <template #body="{ data }">
                    <div class="flex flex-wrap gap-2">
                        <BaseEntityTypeTag
                            v-for="entity in data.entity_types"
                            :key="entity"
                            :entity-type="entity"
                        />
                    </div>
                </template>
            </Column>
            <Column field="active" header="Status" sortable>
                <template #body="{ data }">
                    <div v-if="isPredefinedTab">
                        <ToggleSwitch v-model="data.active" @change="emit('status-change', { slug: data.slug, active: data.active })" />
                    </div>
                    <div v-else>
                        <Tag :value="data.active ? 'Ativo' : 'Inativo'" :severity="data.active ? 'success' : 'danger'" />
                    </div>
                </template>
            </Column>
            <Column v-if="!isPredefinedTab" header="Ações">
                <template #body="{ data }">
                    <div class="flex gap-2 justify-end">
                        <!-- Copies mirror a predefined type and aren't editable — only removable. -->
                        <BaseButton
                            v-if="data.origin !== 'copy'"
                            icon="edit"
                            text
                            rounded
                            @click="emit('edit', data)"
                        />
                        <BaseButton icon="delete" text rounded severity="danger" @click="emit('delete', data)" />
                    </div>
                </template>
            </Column>
            <template #empty>
                <div class="text-center p-4">
                    Nenhum tipo de relacionamento encontrado.
                </div>
            </template>
        </DataTable>
    </div>
</template>

<script setup>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Tag from 'primevue/tag'
import ToggleSwitch from 'primevue/toggleswitch'
import BaseButton from '@/components/base/BaseButton.vue'
import BaseEntityTypeTag from '@/components/base/BaseEntityTypeTag.vue'

defineProps({
    relationshipTypes: {
        type: Array,
        required: true
    },
    isLoading: {
        type: Boolean,
        default: false
    },
    isPredefinedTab: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['edit', 'delete', 'status-change'])
</script>
